<div [ngClass]="{
                    'nav-sidebar-contents-expand' : isExpandedInitially,
                    'nav-sidebar-contents-collapse' : !isExpandedInitially,
                    'nav-sidebar-collapsed' : isExpandedInitially && !isNavSidebarExpanded,
                    'nav-sidebar-expanded' : !isExpandedInitially && isNavSidebarExpanded  
                }">
    <button class="nav-sidebar-collapse-button" (click)="onCollapseButtonClick()">
        <div class="nav-sidebar-arrow">
            <div class="nav-sidebar-circle">
                <i class="nav-sidebar-icon fas " [ngClass]="isExpandedInitially ? 'fa-angles-left' : 'fa-angles-right'"></i>
            </div>
        </div>
    </button>
    <div class="nav-sidebar-menu-items" [ngClass]="isOverflowScroll ? 'nav-sidebar-scroll' : 'nav-sidebar-visible'" #parentElement>
        <div class="nav-sidebar-home"
            [ngClass]="!isNavSidebarExpanded ? 'nav-sidebar-collapsed' : ''">
            <a routerLink="{{homeUrl}}" class="nav-sidebar-links">
                <div class="nav-sidebar-circle">
                    <i class="fal fa-house nav-sidebar-icon"></i>
                </div>
                <span class="nav-sidebar-home-title" [ngClass]="!isNavSidebarExpanded ? 'nav-sidebar-collapsed' : ''">
                    HOME
                </span>
            </a>
        </div>
        <div *ngFor="let menu of model.menus; let i = index" class="nav-sidebar-menu-container" 
             [ngClass]="!isNavSidebarExpanded ? 'nav-sidebar-collapsed' : ''" 
             (mouseenter)="!isNavSidebarExpanded ? setMouseOver(menu.title) : ''" (mouseleave)="setMouseLeave()">
            <button class="nav-sidebar-menu-header" (click)="isNavSidebarExpanded ? expand(i) : ''" 
            [ngClass]="{
                            'nav-sidebar-open' : isMenuOpen(i) && isNavSidebarExpanded,
                            'nav-sidebar-active' : model.activeMenu === menu
                        }">
                <div class="nav-sidebar-circle">
                    <i class="fal {{menu.icon}} nav-sidebar-icon"></i>
                </div>
                <div class="nav-sidebar-sub-menu-title" [ngClass]="!isNavSidebarExpanded ? 'nav-sidebar-collapsed' : ''">
                    {{menu.title}}
                    <i *ngIf="isNavSidebarExpanded" class="fas fa-caret-down nav-sidebar-icon" [ngClass]="isMenuOpen(i) ? 'nav-sidebar-open' : ''"></i>
                </div>
            </button>
            <div class="nav-sidebar-menu-entries-container" #menuItem [ngStyle]="{'max-height' : isMenuOpen(i) && isNavSidebarExpanded ? getHeight(i) : ''}" [ngClass]="!isNavSidebarExpanded ? 'nav-sidebar-collapsed' : ''">
                <div class="nav-sidebar-menu-entries" [ngClass]="!isNavSidebarExpanded ? 'nav-sidebar-collapsed' : ''">
                    <ng-container *ngIf="menu.groupedMenus">
                        <ng-container *ngFor="let groupedMenu of menu.groupedMenus">
                            <div class="nav-sidebar-entry-header">{{groupedMenu.header}}</div>
                            <div class="nav-sidebar-entry" routerLinkActive="nav-sidebar-active" *ngFor="let groupedItem of groupedMenu.menuItems">
                                <div class="nav-sidebar-entry-selector"></div>
                                <a class="nav-sidebar-entry-link nav-sidebar-links" 
                                routerLink="/{{groupedItem.url}}" #activeLinkItem>
                                    {{groupedItem.title}}
                                </a>
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="!menu.groupedMenus">
                        <div *ngFor="let item of menu.menuItems" class="nav-sidebar-entry" routerLinkActive="nav-sidebar-active">
                            <div class="nav-sidebar-entry-selector"></div>
                            <a class="nav-sidebar-entry-link nav-sidebar-links" 
                            routerLink="/{{item.url}}" #activeLinkItem>
                                {{item.title}}
                            </a>
                        </div>
                    </ng-container>
                </div>
            </div>
            <!-- collapsed menu -->
            <div *ngIf="!isNavSidebarExpanded && mouseOverString === menu.title" class="nav-sidebar-collapsed-menu-container" @fade (@fade.start)="changeScrollbar()">
                <div class="nav-sidebar-collapsed-menu" #collapsedMenu>
                    <ng-container *ngIf="menu.groupedMenus">
                        <ng-container *ngFor="let groupedMenu of menu.groupedMenus">
                            <div class="nav-sidebar-entry-header">{{groupedMenu.header}}</div>
                            <div class="nav-sidebar-entry" routerLinkActive="nav-sidebar-active" *ngFor="let groupedItem of groupedMenu.menuItems">
                                <div class="nav-sidebar-entry-selector"></div>
                                <a class="nav-sidebar-entry-link nav-sidebar-links" 
                                routerLink="/{{groupedItem.url}}" #collapsedMenuActiveLink>
                                    {{groupedItem.title}}
                                </a>
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="!menu.groupedMenus">
                        <ng-container *ngFor="let item of menu.menuItems">
                            <div class="nav-sidebar-entry" routerLinkActive="nav-sidebar-active">
                                <div class="nav-sidebar-entry-selector"></div>
                                <a class="nav-sidebar-entry-link nav-sidebar-links" 
                                routerLink="/{{item.url}}" #collapsedMenuActiveLink>
                                    {{item.title}}
                                </a>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="nav-sidebar-copyright">
        <app-copyright [shouldShowFull]="isNavSidebarExpanded"></app-copyright>
    </div> 
</div>